// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"O_-z","narrowOptionButtons":"P_-z","noOptions":"Q_-z"};